import React from 'react' 
import { template } from '../layouts' 
import FooterMenu from './footer/FooterMenu'
import { Widgets } from '../utilities'

const LayoutFooter = (props: any) => {
  return template().footer
      ?
      <div className="layout-footer-container" data-testid="layout-footer-container">
        <Widgets areaName="layout-before-footer" data={{ ...props }} />
        <div className="layout-footer-menu" data-testid="layout-footer-menu">
          <div 
            className='pe-footer-menu-container'
            style={{ background: template().footer.bg }}
          >
            <div className='flex-centered flex-wrap'>
              <Widgets areaName="layout-footer-menu" data={{ ...props }} defArea={<FooterMenu />}/>
              <div className="d-none d-md-flex">
                <Widgets areaName="footer-menu" data={{}} />   
              </div> 
            </div>
          </div>
        </div>
        <div className="layout-footer" data-testid="layout-footer">
          <Widgets areaName="layout-footer" data={{ ...props }} /> 
        </div>
        <div className="layout-under-footer" data-testid="layout-under-footer">
          <Widgets areaName="layout-under-footer" data={{ ...props }} /> 
        </div>
      </div>
      :
      null
} 

export default LayoutFooter